import { NavigationState } from '../store/navigation.type';
import { ActiveModules, SettingsState } from '../store/settings.type';
import { UserState } from '../store/user.type';
import { Literal, Record, Static, String, Union } from 'runtypes';

export const AppConfig = Record({
  appName: String,
  activeModules: ActiveModules,
});

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AppConfig = Static<typeof AppConfig>;

export interface IState {
  navigation: NavigationState;
  settings: SettingsState;
  user: UserState;
}

export type AvailabilityInfo = {
  [date in string]: {
    isAvailable: boolean;
    slots: Slots;
  };
};

export type Slots = {
  [time in string]: number;
};

export const KnownErrorType = Union(Literal('time-slot-not-available'));
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type KnownErrorType = Static<typeof KnownErrorType>;

export const KnownError = Record({
  error: KnownErrorType,
});
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type KnownError = Static<typeof KnownError>;
